import css from "classnames";
import * as React from "react";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    datetime: string;
}

function TimeComponent({ datetime }: Props): JSX.Element | null {
    if (datetime.length === 0) {
        return null;
    }

    const splitDateAndTime = datetime.split(" ");

    let date;
    let time;

    if (splitDateAndTime && splitDateAndTime.length === 2) {
        date = splitDateAndTime[0];
        time = splitDateAndTime[1];
    }

    let timeComponent;
    if (time && date) {
        if (date.endsWith(".")) {
            date = date.slice(0, -1);
        }
        timeComponent = (
            <section className={css(styles.datetime)}>
                <div className={css(styles.time)}>{time}</div>
                <div className={css(styles.date)}>{date}</div>
            </section>
        );
    } else {
        timeComponent = (
            <div className={css(styles.datetime, styles.single)}>
                {datetime}
            </div>
        );
    }

    return timeComponent;
}

export default TimeComponent;
